<f-top-nav [flexibleTopNav]="flexibleTopNav">
  <ng-container fLogoContainer>
    @if (!((shouldHideComponents$ | async) || (isImpersonating$ | async))) {
    <ca-app-switcher></ca-app-switcher>
    }
    <ca-logo [showTitle]="(showApplicationTitle$ | async)!"></ca-logo>
  </ng-container>
  <ng-container fSelectorContainer>
    <div class="d-flex align-items-center column-gap-4">
      @if (showConsultantSelector$ | async) {
      <ca-consultants-client-selector></ca-consultants-client-selector>
      } @if(showSecuritySelector$ | async) {
      <ca-security-selector
        [securities]="(applicationSecurities$ | async) || []"
        [selected]="(applicationSelectedSecurity$ | async)!"
        (setSecurities)="onSetSecurities()"
        (securityIdSelected)="onApplicationSecuritySelected($event)"
      >
      </ca-security-selector>
      }
    </div>
  </ng-container>

  <ng-container fToggleContainer>
    @if (!(shouldHideComponents$ | async)) {
    <ca-surveillance-toggle
      class="text-truncate"
      *ngIf="toggleSettings.isShown | async"
      [checked]="!!(toggleSettings.value | async)"
      [label]="toggleSettings.localizationKey"
      (toggle)="onSurveillanceToggle()"
    ></ca-surveillance-toggle>
    }
  </ng-container>
  <ng-container fSearchContainer>
    @if (!(shouldHideComponents$ | async)) {
    <ng-content></ng-content>
    }
  </ng-container>

  <ng-container fAlertsContainer>
    @if(shouldShowAlertsIcon()) {
    <f-icon-notification-button
      data-automation-id="alerts-bell-button"
      caLocalizationScope="navigation"
      [title]="'notificationCenter' | caLocalize"
      [notificationCount]="enableNotificationCenter() ? notificationBellCount() : 0"
      (buttonClick)="openNotificationsPanel()"
    ></f-icon-notification-button>
    }
  </ng-container>

  <ng-container fFeedbackContainer>
    @if(!(shouldHideFeedbackButton$ | async)) {
    <button
      class="btn btn-secondary btn-icon"
      type="button"
      caLocalizationScope="navigation"
      [ngbTooltip]="'feedbackPortalTooltip' | caLocalize"
      placement="bottom-left"
      #tooltip="ngbTooltip"
      (click)="openPendoPortal()"
      data-automation-id="feedback-portal-button"
    >
      <i class="f-i f-i-feedback"></i>
    </button>
    }
  </ng-container>
  <ng-container fEntityContainer>
    @if (!(shouldHideComponents$ | async)) {
    <ca-add-entity-dropdown
      data-automation-id="ca-addressbook-dropdown"
      [icon]="entityIcon"
      [list]="entityList"
      [tooltip]="'newEntityTooltip'"
      (itemClick)="entityItemClick($event)"
    ></ca-add-entity-dropdown>
    }
  </ng-container>
  <ng-container fActivityContainer>
    @if (!(shouldHideComponents$ | async)) {
    <ca-add-entity-dropdown
      data-automation-id="ca-event-dropdown"
      [icon]="'f-i-calendar-add'"
      [list]="eventList"
      [tooltip]="'newActivityEventTooltip'"
      (itemClick)="eventItemClick($event)"
      [btnStyle]="'btn-secondary ca-event-dropdown-btn'"
    ></ca-add-entity-dropdown>
    }
  </ng-container>
  <ng-container fUserMenuContainer>
    <f-dropdown-with-initials
      [user]="user$ | async"
      [items]="userSettingsOptions$ | async"
      (itemClick)="userItemClick($event)"
    ></f-dropdown-with-initials>
  </ng-container>
</f-top-nav>
